<div class="layout">
    <div class="image">Image</div>
    <div class="name">Name</div>
    <div class="price">Price</div>
    <div class="description">Description</div>
    <div class="edit"></div>
</div>



